// Version for BK. Keep in sync with other brands if needed

export default {
  localStorage: 9, // Updating this will cause the region/lang modal to be shown on multi-lang regions
  cookie: 1,
};
